/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { ISearchBarOption } from '@msdyn365-commerce/components';
import { ICustomOrderHistoryResources } from '../custom-order-history.props.autogenerated';
import { SearchOption } from './search-option';

export function mapSearchOptionIntoISearchBarOption(searchOption: SearchOption, resources: ICustomOrderHistoryResources): ISearchBarOption {
    switch (searchOption) {
        case SearchOption.OrderNumber:
            return {
                label: resources.orderNumberSearchOptionLabel,
                value: SearchOption.OrderNumber.toString()
            } as ISearchBarOption;
        case SearchOption.ConfirmationId:
            return {
                label: resources.confirmationIdSearchOptionLabel,
                value: SearchOption.ConfirmationId.toString()
            } as ISearchBarOption;
        case SearchOption.ChannelName:
            return {
                label: resources.channelNameSearchOptionLabel,
                value: SearchOption.ChannelName.toString()
            } as ISearchBarOption;
        case SearchOption.CustomerRequisition:
            return {
                label: resources.customerRequistionSearchOptionLabel,
                value: SearchOption.CustomerRequisition.toString()
            } as ISearchBarOption;
        default:
            throw new Error(`Invalid search option: ${searchOption}`);
    }
}

export function mapISearchBarOptionIntoSearchOption(searchBarOption?: ISearchBarOption): SearchOption | undefined {
    if (!searchBarOption) {
        return;
    }

    if (searchBarOption.value === SearchOption.OrderNumber.toString()) {
        return SearchOption.OrderNumber;
    }

    if (searchBarOption.value === SearchOption.ConfirmationId.toString()) {
        return SearchOption.ConfirmationId;
    }

    if (searchBarOption.value === SearchOption.ChannelName.toString()) {
        return SearchOption.ChannelName;
    }

    if (searchBarOption.value === SearchOption.CustomerRequisition.toString()) {
        return SearchOption.CustomerRequisition;
    }

    return;
}
